import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingOnHoldDialog extends Layout {
    labelHeader: Label;
    panelOnHold: Panel;
    sourceBilling: DataSource;
    textboxOnHoldDescription: Textbox;
    textboxOnHoldReasonCode: Textbox;
}
